import { render, staticRenderFns } from "./LatestBusinessOffers.vue?vue&type=template&id=c2c60d4e"
import script from "./LatestBusinessOffers.vue?vue&type=script&lang=js"
export * from "./LatestBusinessOffers.vue?vue&type=script&lang=js"
import style0 from "./LatestBusinessOffers.vue?vue&type=style&index=0&id=c2c60d4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports